module.exports = __webpack_public_path__ + "media/stylesheets/images/martech/efo_features_11-6d37e78b7edce67c0b5ecb49af7bd4c0.png";